"use client";
import React, { useState } from "react";
import HeroSection from "@/components/industry-co-led/HeroSection";
import AboutProgram from "@/components/industry-co-led/AboutProgram";
import OurOffering from "@/components/industry-co-led/OurOffering";
import { nutritionAndDietetics } from "@/data/industry-co-led/Emversity/nutritionAndDietetics";
import { courseDetails } from "@/data/industry-co-led/redversity/courseDetails";
import WhySection from "@/components/industry-co-led/WhySection";
import MSUAdvantages from "@/components/industry-co-led/MSUAdvantages";
import CTASection from "@/components/industry-co-led/ui/CTASection";
import CurriculumStructure from "@/components/industry-co-led/CurriculumStructure";
import StudentStoriesSection from "@/components/industry-co-led/medhavianSpeak";
import FAQSection from "@/components/industry-co-led/FAQSection";
import InfrastructureSection from "@/components/industry-co-led/InfrastructureSection";
import AdditionalSkills from "@/components/industry-co-led/addintionSkill";
import OnTheJobTraining from "@/components/industry-co-led/OnTheJobTraining";
import UserFormModal from "@/components/industry-co-led/user-form-otp/UserFormModal";
import { useFormModal } from "@/context/FormContext";
import VideoModal from "@/components/videoModel";
import EligibilitySection from "@/components/industry-co-led/EligibilitySection";
import CareerProspects from "@/components/industry-co-led/CareerProspects";
import CourseStickyBar from "@/components/industry-co-led/CourseSticky";

const NutritionAndDietetics = () => {
  const {
    isOpen,
    shouldDownload,
    closeForm,
    handleSuccess,
    openDownloadForm,
    openApplyForm,
    modal,
    closeVideo,
  } = useFormModal();

  const brochureUrl =
    "https://cdn.msu.edu.in/pdf/MSU_Fee_Structure_2026_27.pdf";

  const brochureName = "MSU-FEE-STRUCTURE-2026-27.pdf";

  return (
    <>
      <section className="w-full ">
        <HeroSection
          data={nutritionAndDietetics}
          onDownload={() => openDownloadForm(brochureUrl, brochureName)}
          onApply={() => openApplyForm()}
        />
        <AboutProgram data={nutritionAndDietetics} />
        <OurOffering data={nutritionAndDietetics} />
        <WhySection data={nutritionAndDietetics} />
        <MSUAdvantages data={nutritionAndDietetics} />
        <CTASection
          data={nutritionAndDietetics}
          onApplyNow={openApplyForm}
        />
        {/* <OnTheJobTraining data={nutritionAndDietetics.onJobtrainningData} /> */}
        <AdditionalSkills
          courseSections={nutritionAndDietetics.addtionSkill.courseSections}
          onApplyNow={openApplyForm}
        />
        <InfrastructureSection
          data={nutritionAndDietetics.DoExperienceLearndata}
        />
        <StudentStoriesSection
          studentStoriesData={nutritionAndDietetics.studentStoriesData}
        />
        <EligibilitySection
          data={nutritionAndDietetics}
          onApplyNow={openApplyForm}
        />
        <CareerProspects data={nutritionAndDietetics.careerProspects} />

        <CurriculumStructure
          curriculumData={nutritionAndDietetics.curriculumStructure}
        />
        <FAQSection course={nutritionAndDietetics.faq} />
      </section>

      <UserFormModal
        isOpen={isOpen}
        onClose={closeForm}
        onSuccess={handleSuccess}
        shouldDownload={shouldDownload}
        courseDetails={courseDetails.redversity.UG}
        specialization={"Nutrition and Dietetics"}
        course={"Bachelors (4 Years)"}
        schoolName={"Health Science & Technology"}
        stream={""}
        apiUrl={'https://lp.msu.edu.in/lead/api/industry-co-lead/emversity'}

      />

      <VideoModal open={modal.open} url={modal.url} onClose={closeVideo} />
      <CourseStickyBar
        coursePrice={nutritionAndDietetics.coursePrice}
        onApply={() => openApplyForm()}
      />
    </>
  );
};

export default NutritionAndDietetics;
